import uiRouter from '@uirouter/angularjs';

import './backButton.scss';

export const BackButtonComponentModule = angular
    .module('app.components.pageHeader.backButton', [uiRouter])
    .component('backButton', {
        template: `
            <md-button
                class="md-icon-button back-button back-button--{{$ctrl.themeName}}"
                gtm-click-event="{{$ctrl.gtmId}}_back"
                ng-click="$ctrl.onButtonClick()"
                ng-disabled="$ctrl.shouldShowSpinner()"
                aria-label="Back to previous page">
                <md-icon id="{{$ctrl.gtmId}}" ng-if="!$ctrl.shouldShowSpinner()">arrow_back</md-icon>
                <md-progress-circular
                    ng-if="$ctrl.shouldShowSpinner()"
                    md-diameter="24"
                    md-mode="indeterminate"
                    ng-class="{'progress-white': $ctrl.themeName === 'light',
                        'progress-dark': $ctrl.themeName === 'dark'}">
                </md-progress-circular>
            </md-button>
        `,
        bindings: {
            showSpinner: '<',
            stateName: '@',
            gtmId: '<',
            theme: '@',
            onClick: '&'
        },
        controller: class BackButtonController {
            constructor($state, $attrs) {
                'ngInject';

                angular.extend(this, {
                    loading: false,
                    themeName: this.theme === 'dark' ? 'dark' : 'light',
                    $state,
                    $attrs
                });
            }

            onButtonClick() {
                if (this.stateName) {
                    this.loading = true;
                    this.$state.go(this.stateName).then(() => {
                        this.loading = false;
                    });
                }
                if (this.$attrs.onClick) {
                    this.onClick();
                }
            }

            shouldShowSpinner() {
                return this.showSpinner && this.loading;
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/pageHeader/backButton/backButton.js